import { useMemo } from "react";
import { CodeYellow, RespondingProvider } from "../types/CodeYellow";

export const getIsRespondingProviderOptedIn = (
  respondingProvider: RespondingProvider | undefined,
) => {
  if (respondingProvider == null) {
    return false;
  }

  return respondingProvider.timeOptIn ? true : false;
};

const useRespondingProvidersCount = (codeYellow: CodeYellow) => {
  const respondingProvidersCount = useMemo(() => {
    return (codeYellow.respondingProviders || []).filter((respondingProvider) =>
      getIsRespondingProviderOptedIn(respondingProvider),
    ).length;
  }, [codeYellow.respondingProviders]);
  return respondingProvidersCount;
};

export default useRespondingProvidersCount;
